import ServicePage from "@/components/ServicePage";
export default function Esthetics() {
  return <ServicePage slug="facials" />;
}
